import React, { FunctionComponent } from "react";
import Link from "next/link";

import { Org } from "src/lib/graphql/types";

type OrgProfileSidebarProps = {
  org: Org;
};

const OrgSubOrganizations: FunctionComponent<OrgProfileSidebarProps> = ({
  org,
}) => {
  return (org.subOrganization || []).length > 0 ? (
    <div className="index-profile-sidebar large-text">
      <div className="container">
        <div className="sub-org sidebar-field">
          <div className="field-label">Sub-organizations</div>
          <ul>
            {org.subOrganization!.map((elem) => (
              <li key={elem.id} className="sub-org-item ellipsis">
                <Link href={`/@${elem.shortname}`} prefetch={false}>
                  <a>{elem.name}</a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  ) : null;
};

export default OrgSubOrganizations;
